import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-[var(--ibp-offwhite)] px-4">
      <div className="text-center">
        <p className="font-[var(--font-heading)] text-6xl font-bold text-[var(--ibp-navy-900)]">
          404
        </p>
        <h1 className="mt-3 font-[var(--font-heading)] text-2xl font-semibold text-[var(--ibp-ink)]">
          Page not found
        </h1>
        <p className="mt-2 text-sm text-[color:rgba(11,18,32,0.65)]">
          The page you’re looking for doesn’t exist or has moved.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-[var(--ibp-gold-500)] px-5 py-3 text-sm font-semibold text-[var(--ibp-ink)] transition-colors hover:bg-[var(--ibp-primary-hover)]"
        >
          <HomeIcon className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
